import React from 'react';
import OidcAuthProvider from './OidcAuthProvider';

export default function AuthProvider({ children }: { children: React.ReactNode }) {
  return <OidcAuthProvider>{children}</OidcAuthProvider>;
}
